// @flow

import * as React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import Button from 'app/common/button';
import i18n from 'app/common/i18n';

type Props = {
  onClose: () => void,
  onConfirm: () => void
};

type State = {};

class ConfirmDialog extends React.Component<Props, State> {
  state = {
    modalOpen: false
  };

  handleClose = () => {
    this.setState({ modalOpen: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  handleOpen = () => {
    this.setState({ modalOpen: true });
  };

  handleConfirm = () => {
    if (this.props.onConfirm) {
      this.props.onConfirm();
    } else if (this.props.onClick) {
      this.props.onClick();
    }
  };

  renderModal() {
    if (!this.state.modalOpen) {
      return null;
    }

    const { title, content } = this.props.dialogProps || {};

    const actions = [
      <Button
        key="cancel"
        secondary
        flat
        label={this.props.i18n('Cancel')}
        onClick={this.handleClose}
        style={{ marginLeft: '12px' }}
      />,
      <Button
        key="submit"
        primary
        autoFocus
        label={this.props.i18n('Confirm')}
        onClick={this.handleConfirm}
        style={{ marginLeft: '12px' }}
      />
    ];

    return (
      <Dialog
        fullWidth
        fullScreen={this.props.fullScreen}
        open
        onClose={this.handleClose}
        className={'dialog-common'}
      >
        <DialogTitle>{title || this.props.i18n('Confirm action')}</DialogTitle>
        {content && <DialogContent>{content()}</DialogContent>}
        <DialogActions>{actions}</DialogActions>
      </Dialog>
    );
  }

  render() {
    const {
      component: ButtonComponent = Button,
      buttonProps = {}
    } = this.props;

    return (
      <React.Fragment>
        {this.renderModal()}
        <ButtonComponent {...buttonProps} onClick={this.handleOpen} />
      </React.Fragment>
    );
  }
}

const ConfirmDialogI18n = i18n(ConfirmDialog);

function ConfirmDialogWithMobileDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return <ConfirmDialogI18n {...props} fullScreen={fullScreen} />;
}

export default ConfirmDialogWithMobileDialog;